import React from "react";
import Helmet from "react-helmet";
import TopicList from "app/topics/TopicList";
import TopicLayout from "app/topics/TopicLayout";
import styled from "styled-components";
import { Colors } from "@blueprintjs/core";
import { injectIntl } from "react-intl";

export const Page = styled.div`
  min-height: 100% ;
  display: flex;
  background-color: ${Colors.LIGHT_GRAY3};
  & > * {
    flex 1;
    margin: auto;
  }
`;

const TopicsPage = ({ intl }) => {
  const title = intl.formatMessage({
    id: "app.topics",
    defaultMessage: "Topics"
  });
  return (
    <TopicLayout
      main={
        <Page>
          <Helmet title={title} />
          <TopicList />
        </Page>
      }
    />
  );
};

export default injectIntl(TopicsPage);



// WEBPACK FOOTER //
// ./src/app/topics/TopicsPage.js